export default {
      id: "link-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#link",
      toString: function () {
        return this.url;
      }
    }